import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=1f97d3b9&"
import script from "./summary.vue?vue&type=script&lang=js&"
export * from "./summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f97d3b9')) {
      api.createRecord('1f97d3b9', component.options)
    } else {
      api.reload('1f97d3b9', component.options)
    }
    module.hot.accept("./summary.vue?vue&type=template&id=1f97d3b9&", function () {
      api.rerender('1f97d3b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/componetsPage/summary.vue"
export default component.exports